import { APP_NAME } from '@/consts/core'

export const setDocumentTitle = (title: string) => {
  document.title = `${title} | ${APP_NAME}`
}
